export function formatLocale(locale: string | undefined | null) {
  if (!locale || !locale.includes("_")) return locale || "";
  const [country, language] = locale.split("_");
  return `${language.toLowerCase()}_${country.toUpperCase()}`;
}
